/** Results sent to teachers, and the inbox a teacher reads them in. */
import { baseApi } from '../baseApi';
import type {
  AttemptSubmissions,
  InboxDetail,
  InboxItem,
  InboxPage,
  ReviewIn,
} from '../types';

export const submissionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAttemptSubmissions: build.query<AttemptSubmissions, string>({
      query: (attemptId) => `/attempts/${attemptId}/submissions`,
      providesTags: ['Submissions'],
    }),
    sendAttempt: build.mutation<AttemptSubmissions, { attemptId: string; teacherIds: string[] }>({
      query: ({ attemptId, teacherIds }) => ({
        url: `/attempts/${attemptId}/submissions`,
        method: 'POST',
        body: { teacherIds },
      }),
      invalidatesTags: ['Submissions'],
    }),
    listInbox: build.query<
      InboxPage,
      { lang: string; reviewed?: boolean; studentId?: string; cursor?: string }
    >({
      query: (params) => ({ url: '/teaching/inbox', params }),
      providesTags: ['Submissions'],
    }),
    getInboxItem: build.query<InboxDetail, { id: string; lang: string }>({
      query: ({ id, lang }) => ({ url: `/teaching/inbox/${id}`, params: { lang } }),
      providesTags: ['Submissions'],
    }),
    reviewInboxItem: build.mutation<InboxItem, { id: string; lang: string; body: ReviewIn }>({
      query: ({ id, lang, body }) => ({
        url: `/teaching/inbox/${id}`,
        method: 'PATCH',
        params: { lang },
        body,
      }),
      invalidatesTags: ['Submissions'],
    }),
  }),
});

export const {
  useGetAttemptSubmissionsQuery,
  useSendAttemptMutation,
  useListInboxQuery,
  useGetInboxItemQuery,
  useReviewInboxItemMutation,
} = submissionsApi;
